import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  ElementPlacementDirective,
  ElementSetupService, LayoutElement,
  ScreenComposerComponent,
  ScreenConfig, ScreenErrorMsgComponent,
} from "@tbg/ui-components";

@Component({
  selector: 'app-screen-test',
  standalone: false,
  template: `
      <div class="card bg-[#fafafa]">
        <ng-template elementPlacement></ng-template>
    </div>
  `,
  styles: [
  ]
})
export class ScreenContainerComponent implements OnInit, AfterViewInit{

  config!: ScreenConfig;
  @ViewChild(ElementPlacementDirective, {static: true}) elementPlacement!: ElementPlacementDirective;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private setupService: ElementSetupService
  ) {}

  screenConfig = {
    key: "screen-uuid-123",
  } as ScreenConfig;

  ngOnInit(): void {
    this.route.params.subscribe( params => {
      const key = params['key']
      this.config = this.createConfig(key);
    });
  }

  private createConfig(key: string): ScreenConfig{
    return {
      key: key
    }
  }

  loadComponent(){
    const viewContainerRef = this.elementPlacement.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<ScreenComposerComponent>(ScreenComposerComponent);
    this.setupService.setup(ScreenComposerComponent, componentRef, this.config)
      .subscribe({
          next: data => {},
          error: err => {
            console.error(`Error while loading for component ${componentRef.instance.name}: ${err}`)
            if (err.status === 401) {
              console.info("redirect to login page")
              this.router.navigate(['/login']);
            } else {
              this.loadErrorMessageComponent();
            }
          },
          complete: () => console.info(`%c Component ${componentRef.instance.name} loaded`, 'color:blue;')

        }
      )
    ;
  }

  ngAfterViewInit(): void {
    this.loadComponent();
  }

  loadErrorMessageComponent(){
    const componentClass = ScreenErrorMsgComponent;
    if(componentClass){
      const viewContainerRef = this.elementPlacement.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent<LayoutElement>(componentClass);
      this.setupService.setup(componentClass, componentRef, this.config)
        .subscribe({
          next: () => console.log("Rendering the screen error msg component"),
          complete: () => this.setupService.componentOutputsSetup(componentRef, this.config)
        });
    }
  }

}
